/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable no-shadow */
import { jwtDecode } from 'jwt-decode';

export const authTokenCookie = () => {
  // gets cookie and returns it as a key=value object
  try {
    const cookies = document.cookie ? document.cookie.split(';') : null;
    let cookieVal;
    let idcookie;
    let idField;
    let fields;
    let cookieUrl;
    if (cookies) {
      const cookie = cookies.filter((cookie) => cookie.includes('ent-abs-auth'));
      idcookie = cookies.find((cookie) => cookie.includes('ent-abs-itkn'));
      cookieVal = cookie.length ? cookie[0] : null;
      cookieUrl = cookies.find((cookie) => cookie.includes('abs-url'));
    }
    fields = cookieVal ? cookieVal.split('=') : null;
    idField = idcookie ? idcookie.split('=') : null;
    const authCookie = {
      name: fields ? fields[1] : null,
    };
    const token = authCookie.name ? authCookie.name : null;
    const idToken = idField ? idField[1] : null;
    const decodedToken = token ? jwtDecode(token) : (null as any);
    const decodedIdToken = idToken ? jwtDecode(idToken) : (null as any);

    return {
      authCookie,
      token,
      idToken,
      userInfo: {
        name: decodedIdToken && decodedIdToken.name ? decodedIdToken.name : null,
        userId: decodedIdToken && decodedIdToken.onpremisessamaccountname ? decodedIdToken.onpremisessamaccountname : null,
        emailId: decodedIdToken && decodedIdToken.preferred_username ? decodedIdToken.preferred_username : null,
        userRole: null,
        allUserRole: decodedIdToken && decodedIdToken.roles && decodedIdToken.roles[0] ? decodedIdToken.roles : null,
        userStore: decodedIdToken && decodedIdToken.swyFacilityCode ? decodedIdToken.swyFacilityCode : null,
        userDistrict: decodedIdToken && decodedIdToken.swyDistrict ? decodedIdToken.swyDistrict : null,
        userDivision: decodedIdToken && decodedIdToken.swyDivision ? decodedIdToken.swyDivision : null,
      },
      authUrl: cookieUrl,
      tid: decodedToken ? decodedToken.tid : null,
      decodedToken,
      decodedIdToken,
    };
  } catch (err) {
    console.log('CookieError:--------------');
    console.log(err);
    console.log('CookieErrorEnds:--------------');
  }
};
